import React from "react";

const Footer = () => {
  return (
    <div className="d-flex justify-content-between pt-5 pb-3 footer-text">
      <span>© 2026 ARM Financial. All rights reserved.</span>
      <span
        className="cursor-pointer fw-bold footer-text"
        style={{
          color: "var(--accent-color)",
        }}
      >
        cookies preference
      </span>
    </div>
  );
};

export default Footer;
